import { createSelector } from '@reduxjs/toolkit';
import { selectTargetProject, selectCurrentProject } from '../selectors';
import { selectBalanceSupportedTokenObj } from 'src/store/shared/balances/selectors';
import { getColdWalletsSelectors } from 'src/store/shared/cold-wallets/selectors';
import type { TokenTypeMap } from 'src/store/shared/cold-wallets/types';

const selectSupportById = createSelector(
  selectCurrentProject,
  selectBalanceSupportedTokenObj,
  (project, supportedTokens) => {
    if (!project) return [];
    return supportedTokens?.[project.id] ?? [];
  },
);

const selectTokenTypeMap = createSelector(selectSupportById, (supportedTokens) =>
  (supportedTokens ?? []).reduce<TokenTypeMap>(
    (acc, { token, type }: { token: string; type: number }) => {
      acc[token] = type;
      return acc;
    },
    {},
  ),
);

export const { selectWalletsSnapshots, selectColdWallets } = getColdWalletsSelectors(
  selectTargetProject,
  selectTokenTypeMap,
);
